import styled from 'styled-components';
import { Container } from '@tryhackme/thm-ui-components';

export const StyledContainer = styled(Container)`
  padding: 3rem 1.2rem 6rem 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    padding: 3rem 3.6rem 6rem 3.6rem;
    gap: 2.4rem;
  }
`;
